import { BARCODE_MASTER_ELEMENTS as trans } from './translationValues';

export const barcodeElements = t => {
  return [
    {
      id: 303,
      type: 'image',
      categoryId: 185,
      shareType: null,
      thumbnail: '/barCode39.png',
      name: "code 39",
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        barcodeType: 'code39',
        styles: {
          backgroundColor: 'transparent',
          transform: 'translateX(86.2727px) translateY(850.1px) rotate(0deg) scaleX(1) scaleY(1)',
          width: '330px',
          position: 'absolute',
          height: '60px',
        },
        type: 'barcode',
        value: '/barCode39.png',
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 303,
      type: 'image',
      categoryId: 185,
      shareType: null,
      thumbnail: '/barCode.png',
      name: t(
        `BARCODE_MASTER_ELEMENTS:${trans.BARCODE_PDF_LABEL.key}`,
        trans.BARCODE_PDF_LABEL.value,
      ),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        barcodeType: 'pdf417',
        styles: {
          backgroundColor: 'transparent',
          transform: 'translateX(86.2727px) translateY(850.1px) rotate(0deg) scaleX(1) scaleY(1)',
          width: '330px',
          position: 'absolute',
          height: '60px',
        },
        type: 'barcode',
        value: '/barCode.png',
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 302,
      type: 'image',
      categoryId: 185,
      shareType: null,
      thumbnail: '/qr.png',
      name: t(`BARCODE_MASTER_ELEMENTS:${trans.QRCODE_LABEL.key}`, trans.QRCODE_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        barcodeType: 'qr',
        styles: {
          backgroundColor: 'transparent',
          transform: 'translateX(86.2727px) translateY(850.1px) rotate(0deg) scaleX(1) scaleY(1)',
          width: '180px',
          position: 'absolute',
          height: '180px',
        },
        type: 'barcode',
        value: '/qr.png',
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 301,
      type: 'image',
      categoryId: 185,
      shareType: null,
      thumbnail: '/dataMatrix.png',
      name: t(
        `BARCODE_MASTER_ELEMENTS:${trans.DATAMATRIX_LABEL.key}`,
        trans.DATAMATRIX_LABEL.value,
      ),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        barcodeType: 'datamatrix',
        styles: {
          backgroundColor: 'transparent',
          transform: 'translateX(86.2727px) translateY(850.1px) rotate(0deg) scaleX(1) scaleY(1)',
          width: '150px',
          position: 'absolute',
          height: '150px',
        },
        type: 'barcode',
        value: '/dataMatrix.png',
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 300,
      type: 'image',
      categoryId: 185,
      shareType: null,
      thumbnail: '/aztec.png',
      name: t(`BARCODE_MASTER_ELEMENTS:${trans.AZTEC_LABEL.key}`, trans.AZTEC_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        barcodeType: 'aztec',
        styles: {
          backgroundColor: 'transparent',
          transform: 'translateX(86.2727px) translateY(850.1px) rotate(0deg) scaleX(1) scaleY(1)',
          width: '150px',
          position: 'absolute',
          height: '150px',
        },
        type: 'barcode',
        value: '/aztec.png',
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
  ];
};
